export const NUDGE_HOLD_DELAY_MS = 250;
export const NUDGE_RAMP_MS = 1000;
export const NUDGE_START_SPEED = 20;
export const NUDGE_MAX_SPEED = 160;

export function nudgeSpeed(elapsedMs:number):number {
  if(elapsedMs<NUDGE_HOLD_DELAY_MS)return 0;
  const progress=Math.min(1,(elapsedMs-NUDGE_HOLD_DELAY_MS)/NUDGE_RAMP_MS);
  return NUDGE_START_SPEED+(NUDGE_MAX_SPEED-NUDGE_START_SPEED)*progress;
}

export function nudgeFrameDistance(elapsedMs:number,frameMs:number):number {
  return nudgeSpeed(elapsedMs)*Math.max(0,Math.min(frameMs,50))/1000;
}
